import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IBeneficiaryType } from './../../models/contract';
import { IGenericResult, IGenericContract } from 'src/app/models/generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiBeneficiaryService {
  baseUrls: { [key: string]: string } = {
    //baseUrlInvoiceReport: `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.report}`,
    //baseUrlTransferReport: `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.report}`,
    //baseUrlContractReport: `${environment.apis.contracts.baseUrl}/${environment.apis.contracts.microservices.report}`
    baseUrlInvoiceReport: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceReport}`,
    baseUrlTransferReport: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferReport}`,
    baseUrlContractReport: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contractReport}`
  };

  constructor(private _http: HttpClient) { }

  getInvoicingBeneficiaries(
    contractNumber: string,
    queryNumber: string,
    financialInstitution: string,
  ): Observable<IGenericResult<IGenericContract>> {
    return this._http.get<IGenericResult<IGenericContract>>(
      `${this.baseUrls['baseUrlInvoiceReport']}/contract/${contractNumber}/${queryNumber}/${financialInstitution}`
    );
  }

  getTransferBeneficiaries(
    contractNumber: string,
    queryNumber: string,
    financialInstitution: string,
  ): Observable<IGenericResult<IGenericContract>> {
    return this._http.get<IGenericResult<IGenericContract>>(
      `${this.baseUrls['baseUrlTransferReport']}/contract/${contractNumber}/${queryNumber}/${financialInstitution}`
    );
  }

  getBeneficiaryType(): Observable<IGenericResult<IBeneficiaryType[]>> {
    return this._http.get<IGenericResult<IBeneficiaryType[]>>(
      `${this.baseUrls['baseUrlContractReport']}/beneficiary-type`
    );
  }
}
